"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _styles = require("@material-ui/styles");

var _solarReact = require("@solar/solar-react");

var _solarReact2 = require("@probeton/solar-react");

var _i18next = _interopRequireDefault(require("i18next"));

var _appContext = require("./hooks/appContext");

var _LoadingPage = _interopRequireDefault(require("./LoadingPage"));

var _PdfDialogWithNav = _interopRequireDefault(require("./PdfDialogWithNav"));

var _SetPdfRefDialog = _interopRequireDefault(require("./SetPdfRefDialog"));

var _ConfirmDialog = _interopRequireDefault(require("./ConfirmDialog"));

var _AlertDialog = _interopRequireDefault(require("./AlertDialog"));

var _ImageUploadDialog = _interopRequireDefault(require("./ImageUploadDialog"));

var _excluded = ["children"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var imageUploadRegister = {};
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      position: 'relative',
      display: 'flex',
      height: '100%'
    }
  };
});

var App = function App(_ref) {
  var _pdfRef$labels;

  var children = _ref.children,
      history = _ref.history,
      user = _ref.user,
      dialogs = _ref.dialogs,
      sheets = _ref.sheets,
      dataStore = _ref.dataStore,
      NavigationDrawer = _ref.navigationDrawer,
      ProfileInfo = _ref.profileInfo,
      drawerProps = _ref.drawerProps,
      detailViewPanelProps = _ref.detailViewPanelProps,
      dialogProps = _ref.dialogProps,
      app = _ref.app,
      extra = _ref.extra,
      onLogout = _ref.onLogout,
      onToggleTheme = _ref.onToggleTheme,
      getAWSSignedUrl = _ref.getAWSSignedUrl,
      onCropImage = _ref.onCropImage,
      onReplaceImage = _ref.onReplaceImage,
      onAddPdfRef = _ref.onAddPdfRef,
      labels = _ref.labels;

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      _imageUpload = _useState2[0],
      setImageUpload = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      pdfRef = _useState4[0],
      setPdfRef = _useState4[1]; // const theme = useTheme();
  // const isPhone = useMediaQuery(theme.breakpoints.down('sm'));


  (0, _react.useEffect)(function () {
    localStorage.setItem('app', app);
  }, [app]);

  var _useApp = (0, _appContext.useApp)(),
      _useApp2 = _slicedToArray(_useApp, 2),
      _useApp2$ = _useApp2[0],
      imageOpen = _useApp2$.imageOpen,
      pdfOpen = _useApp2$.pdfOpen,
      alertOpen = _useApp2$.alertOpen,
      confirmOpen = _useApp2$.confirmOpen,
      drawerOpen = _useApp2$.drawerOpen,
      dialogRegister = _useApp2$.dialogRegister,
      snack = _useApp2$.snack,
      _useApp2$2 = _useApp2[1],
      setImageOpen = _useApp2$2.setImageOpen,
      setPdfOpen = _useApp2$2.setPdfOpen,
      setAlertOpen = _useApp2$2.setAlertOpen,
      setConfirmOpen = _useApp2$2.setConfirmOpen,
      setDrawerOpen = _useApp2$2.setDrawerOpen,
      setDialogRegister = _useApp2$2.setDialogRegister,
      setSnack = _useApp2$2.setSnack;

  var confirmAction = function confirmAction(_ref2) {
    var _ref2$title = _ref2.title,
        title = _ref2$title === void 0 ? 'Ben je zeker?' : _ref2$title,
        _ref2$body = _ref2.body,
        body = _ref2$body === void 0 ? 'Dit kan niet ongedaan gemaakt worden.' : _ref2$body,
        _ref2$message = _ref2.message,
        message = _ref2$message === void 0 ? null : _ref2$message,
        _ref2$confirmLabel = _ref2.confirmLabel,
        confirmLabel = _ref2$confirmLabel === void 0 ? 'Ok' : _ref2$confirmLabel,
        _ref2$cancelLabel = _ref2.cancelLabel,
        cancelLabel = _ref2$cancelLabel === void 0 ? 'annuleren' : _ref2$cancelLabel;
    return new Promise(function (resolve, reject) {
      setConfirmOpen({
        title: title,
        body: body,
        message: message,
        confirmLabel: confirmLabel,
        cancelLabel: cancelLabel,
        resolve: resolve,
        reject: reject,
        open: true
      });
    });
  };

  var openAlert = function openAlert(_ref3) {
    var _ref3$title = _ref3.title,
        title = _ref3$title === void 0 ? 'Oops...' : _ref3$title,
        _ref3$body = _ref3.body,
        body = _ref3$body === void 0 ? 'Dit is niet gelukt' : _ref3$body,
        message = _ref3.message;
    setAlertOpen({
      title: title,
      body: body,
      message: message,
      open: true
    });
  };

  var mainViewRef = (0, _react.useRef)();

  var handleSetPdfRef = function handleSetPdfRef(prop) {
    return function (id, src, startPage, endPage, metadata, labels) {
      setPdfRef({
        prop: prop,
        id: id,
        src: src,
        startPage: startPage,
        endPage: endPage,
        metadata: metadata,
        labels: labels
      });
    };
  };

  var handleDialog = function handleDialog(dialog, callbackFn) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
      propsForurl: null
    };
    var propsForUrl = options.propsForUrl;

    if (callbackFn && callbackFn !== null) {
      setDialogRegister(function (_ref4) {
        var dialogRegister = _ref4.dialogRegister;
        return {
          dialogRegister: _objectSpread(_objectSpread({}, dialogRegister), {}, _defineProperty({}, dialog, {
            callback: callbackFn,
            propsForUrl: propsForUrl
          }))
        };
      });
    } else {
      setDialogRegister(function (_ref5) {
        var dialogRegister = _ref5.dialogRegister;
        return {
          dialogRegister: _objectSpread(_objectSpread({}, dialogRegister), {}, _defineProperty({}, dialog, null))
        };
      });
    }

    history.addQuery('dialog', dialog);

    if (propsForUrl) {
      Object.entries(propsForUrl).forEach(function (_ref6) {
        var _ref7 = _slicedToArray(_ref6, 2),
            key = _ref7[0],
            value = _ref7[1];

        history.addQuery(key, value);
      });
    }
  };

  var handleSnack = function handleSnack(snack) {
    setSnack(snack);
  };

  var handleCloseSnack = function handleCloseSnack() {
    setSnack(false);
  };

  var _handleDetailViewToggle = function handleDetailViewToggle(detail, id) {
    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var reset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var root = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    history.addQuery(detail, id, reset, root);

    if (props) {
      Object.keys(props).forEach(function (prop) {
        history.setProperty(detail, prop, props[prop]);
      });
    }
  };

  var imageUpload = function imageUpload(_ref8) {
    var title = _ref8.title,
        bucket = _ref8.bucket,
        image = _ref8.image,
        onAdd = _ref8.onAdd,
        onReplace = _ref8.onReplace,
        onCrop = _ref8.onCrop,
        onRemove = _ref8.onRemove;
    imageUploadRegister[bucket] = {
      onAdd: onAdd,
      onReplace: onReplace,
      onCrop: onCrop,
      onRemove: onRemove
    };
    setImageUpload({
      title: title,
      bucket: bucket,
      image: image
    });
  };

  var handleCloseDetailView = function handleCloseDetailView(context) {
    history.removeQuery(context);
  };

  var classes = useStyles(); // this should be in a useEffect.
  // if the user has a language set but i18next has other. Set i18n to user language
  // i18next will use own localStorage key

  if (user && user.profile && user.profile.language && user.profile.language !== _i18next["default"].language) {
    _i18next["default"].changeLanguage(user.profile.language);
  }

  var panels = history.getPanels();
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.root
  }, NavigationDrawer ? /*#__PURE__*/_react["default"].createElement(NavigationDrawer, _extends({
    open: drawerOpen,
    onDrawerRequestClose: function onDrawerRequestClose() {
      return setDrawerOpen(!drawerOpen);
    },
    onDrawerRequestOpen: function onDrawerRequestOpen() {
      return setDrawerOpen(!drawerOpen);
    },
    onClickLogout: function onClickLogout() {
      onLogout();
    },
    user: user,
    onDetailViewToggle: _handleDetailViewToggle,
    handleDialog: handleDialog,
    history: history
  }, drawerProps)) : '', /*#__PURE__*/_react["default"].createElement(_solarReact.ElementWidth, {
    style: {
      width: '100%'
    }
  }, function (_ref9) {
    var width = _ref9.width,
        className = _ref9.className;

    var _responsiveThresholds = (0, _solarReact.responsiveThresholds)(width),
        maxVisiblePanels = _responsiveThresholds.maxVisiblePanels,
        panelWidth = _responsiveThresholds.panelWidth; // console.log({ width, maxVisiblePanels, panelWidth, className });


    return /*#__PURE__*/_react["default"].createElement(_react.Suspense, {
      fallback: /*#__PURE__*/_react["default"].createElement(_LoadingPage["default"], null)
    }, /*#__PURE__*/_react["default"].createElement(_solarReact.Views, null, /*#__PURE__*/_react["default"].createElement(_solarReact2.MainView, {
      setActionBarContainerNode: function setActionBarContainerNode(node) {
        mainViewRef.current = node;
      }
    }, /*#__PURE__*/_react["default"].createElement(_solarReact2.ErrorBoundary, {
      history: history
    }, children({
      handleDetailViewToggle: _handleDetailViewToggle,
      handleDialog: handleDialog,
      handleSnack: handleSnack,
      handleSetPdfRef: handleSetPdfRef,
      confirmAction: confirmAction,
      openAlert: openAlert,
      setPdfOpen: setPdfOpen,
      setImageOpen: setImageOpen,
      imageUpload: imageUpload,
      getAWSSignedUrl: getAWSSignedUrl,
      getActionBarContainer: function getActionBarContainer() {
        return mainViewRef.current;
      }
    }))), /*#__PURE__*/_react["default"].createElement(_solarReact2.ErrorBoundary, {
      history: history
    }, /*#__PURE__*/_react["default"].createElement(_solarReact2.DetailViews, {
      panels: panels,
      components: sheets,
      history: history,
      maxPanels: 4,
      maxVisiblePanels: maxVisiblePanels,
      panelWidth: panelWidth,
      onClose: handleCloseDetailView,
      CloseButton: _solarReact.DetailViewCloseButton,
      panelProps: _objectSpread({
        openDialog: handleDialog,
        openSnack: handleSnack,
        handleSetPdfRef: handleSetPdfRef,
        confirmAction: confirmAction,
        openAlert: openAlert,
        setPdfOpen: setPdfOpen,
        setImageOpen: setImageOpen,
        imageUpload: imageUpload,
        getAWSSignedUrl: getAWSSignedUrl,
        handleDetailViewToggle: function handleDetailViewToggle(detail, id) {
          var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
          var reset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
          var root = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
          return _handleDetailViewToggle(detail, id, props, reset, root);
        },
        currentUser: user,
        user: user,
        onClose: handleCloseDetailView
      }, detailViewPanelProps)
    }))));
  }), /*#__PURE__*/_react["default"].createElement(_ImageUploadDialog["default"], {
    open: !!_imageUpload,
    src: _imageUpload && _imageUpload.image && _imageUpload.image.original,
    cropData: _imageUpload && _imageUpload.image && _imageUpload.image.crop,
    onAdd: function onAdd(data) {
      imageUploadRegister[_imageUpload.bucket].onAdd(data);

      setImageUpload(null);
    },
    onRemove: function onRemove() {
      imageUploadRegister[_imageUpload.bucket].onRemove();

      setImageUpload(null);
    },
    onReplace: function onReplace(data) {
      onReplaceImage(_imageUpload.image._id, data);
      setImageUpload(null);
    },
    onCrop: function onCrop(data) {
      onCropImage(_imageUpload.image._id, data);
      setImageUpload(null);
    },
    title: _imageUpload && _imageUpload.title,
    onClose: function onClose() {
      return setImageUpload(null);
    },
    getAWSSignedUrl: getAWSSignedUrl && getAWSSignedUrl(_imageUpload && _imageUpload.bucket),
    labels: labels.imageUpload
  }), /*#__PURE__*/_react["default"].createElement(_PdfDialogWithNav["default"], {
    isOpen: !!pdfOpen,
    pdfSrc: pdfOpen,
    onClose: function onClose() {
      return setPdfOpen('');
    }
  }), /*#__PURE__*/_react["default"].createElement(_SetPdfRefDialog["default"], {
    pdfRef: pdfRef,
    onCreatePdfRef: onAddPdfRef,
    onClose: function onClose() {
      return setPdfRef(null);
    },
    labels: (_pdfRef$labels = pdfRef === null || pdfRef === void 0 ? void 0 : pdfRef.labels) !== null && _pdfRef$labels !== void 0 ? _pdfRef$labels : {}
  }), /*#__PURE__*/_react["default"].createElement(_core.Dialog, {
    onClose: function onClose() {
      setImageOpen(false);
    },
    fullWidth: true,
    maxWidth: 'xl',
    "aria-labelledby": "simple-dialog-title",
    open: !!imageOpen,
    classes: {
      paper: classes.dialog
    }
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: imageOpen,
    alt: ""
  })), /*#__PURE__*/_react["default"].createElement(_ConfirmDialog["default"], _extends({}, confirmOpen, {
    handle: setConfirmOpen
  })), /*#__PURE__*/_react["default"].createElement(_AlertDialog["default"], _extends({}, alertOpen, {
    handle: setAlertOpen
  })), /*#__PURE__*/_react["default"].createElement(_solarReact2.AppDialogs, {
    dialogs: dialogs,
    dialogProps: _objectSpread({
      handleDetailViewToggle: function handleDetailViewToggle(detail, id) {
        var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        var reset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
        var root = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
        return _handleDetailViewToggle(detail, id, props, reset, root);
      },
      currentUser: user,
      register: dialogRegister
    }, dialogProps),
    panels: panels,
    history: history
  }), /*#__PURE__*/_react["default"].createElement(_core.Snackbar, {
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'left'
    },
    open: Boolean(snack),
    autoHideDuration: 6000,
    onClose: handleCloseSnack,
    ContentProps: {
      'aria-describedby': 'message-id'
    },
    message: /*#__PURE__*/_react["default"].createElement("span", {
      id: "message-id"
    }, snack)
  }), ProfileInfo ? /*#__PURE__*/_react["default"].createElement(ProfileInfo, {
    onClickLogout: function onClickLogout() {
      onLogout();
    },
    onClickLogin: function onClickLogin() {
      history.push('/login');
    },
    user: user,
    onDetailViewToggle: _handleDetailViewToggle,
    handleDialog: handleDialog,
    history: history
  }) : '', extra);
};

App.propTypes = {
  children: _propTypes["default"].func,
  detailViewPanelProps: _propTypes["default"].object,
  dialogProps: _propTypes["default"].object,
  dialogs: _propTypes["default"].object,
  drawerProps: _propTypes["default"].object,
  history: _propTypes["default"].object.isRequired,
  sheets: _propTypes["default"].object,
  user: _propTypes["default"].object
};
App.defaultProps = {
  children: function children() {
    return null;
  },
  detailViewPanelProps: {},
  dialogs: {},
  dialogProps: {},
  drawerProps: {},
  sheets: {},
  user: null
};

var AppWrapper = function AppWrapper(_ref10) {
  var children = _ref10.children,
      props = _objectWithoutProperties(_ref10, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_appContext.AppProvider, null, /*#__PURE__*/_react["default"].createElement(App, props, children));
}; // prettier-ignore


var _default = AppWrapper;
exports["default"] = _default;